import { yupResolver } from '@hookform/resolvers/yup'
import type { EditHeaderProps } from 'components/Card'
import { FormProvider, useForm } from 'react-hook-form'
import { PV1PatientCardEditForm } from './PV1PatientCardEditForm'
import type { PV1PatientCardEditFormSchemaType } from './PV1PatientCardEditForm.validator'
import { PV1PatientCardEditFormSchema } from './PV1PatientCardEditForm.validator'

export const PV1PatientCardEdit = ({
  onSubmit,
  ...props
}: {
  rxPatientData: any
  reviewPatientData: any
  isHumanPatient?: boolean
  editHeaderActions: EditHeaderProps
  onSubmit: (data: PV1PatientCardEditFormSchemaType) => void
}) => {
  const methods = useForm<PV1PatientCardEditFormSchemaType>({
    resolver: yupResolver(PV1PatientCardEditFormSchema),
    reValidateMode: 'onChange',
    defaultValues: {
      patientName: props.reviewPatientData.name || '',
      dob: props.reviewPatientData.dob || '',
      gender: props.reviewPatientData.gender || '',
      species: props.reviewPatientData.species || '',
      weight: props.reviewPatientData.weight || '',
      guardian: props.reviewPatientData.guardian || '',
      address1: props.reviewPatientData.address.street1 || '',
      address2: props.reviewPatientData.address.street2 || '',
      city: props.reviewPatientData.address.city || '',
      zip: props.reviewPatientData.address.zip || '',
      state: props.reviewPatientData.address.state || '',
      phone: props.reviewPatientData.phone || '',
    },
  })

  return (
    <FormProvider {...methods}>
      <PV1PatientCardEditForm {...props} onSubmit={methods.handleSubmit(onSubmit)} />
    </FormProvider>
  )
}
